import { ReactElement } from 'react'
import { CardWrapper, Badge } from '../../../../components'
import { H3, Body } from '../../../../typography'
import { FlexWrapper } from './subcomponents'
import InputGroup from 'react-bootstrap/InputGroup'
import { SelectQuestionProps } from './typings'

const SelectQuestions = ({ isSelected }: SelectQuestionProps): ReactElement => {
  return (
    <>
      <CardWrapper>
        <FlexWrapper hasBorder>
          <H3 hasPadding>Question 1</H3>
        </FlexWrapper>
        <FlexWrapper hasBorder justifyContent="flex-start">
          <InputGroup.Checkbox checked={isSelected} onChange={() => {}} />
          <Badge title={'Difficulty Level'} subTitle="EASY" width="10%"></Badge>
          <Badge title={'Class'} subTitle="12" width="8%"></Badge>
          <Badge
            title={'Question Type'}
            subTitle="Descriptive"
            width="10%"
          ></Badge>
        </FlexWrapper>
        <FlexWrapper hasBorder>
          <Body>Question details</Body>
        </FlexWrapper>
        <FlexWrapper hasBorder>
          <div>
            <Body>Answer:</Body>
            <Body>A) Pharynx</Body>
          </div>
        </FlexWrapper>
      </CardWrapper>
    </>
  )
}

export default SelectQuestions
